import React, { useContext, useEffect, useRef } from "react";
import { ActivityIndicator } from "react-native";
import { useDispatch, useSelector } from "react-redux";
import { Box, ModalContent, Toast, useToast } from "digiwash-components";
import { UIError } from "digiwash-core";

import Modal from "../ReactNativeModal";

import { hasBasicProfileSelector } from "../../ducks/user/selectors";

import PhoneStep from "./PhoneStep-component";
import VerifyStep from "./VerifyStep-component";
import CompleteStep from "./CompleteStep-component";

import { LoginStepEnum } from "../../hooks/useLogin";
import { LoginContext } from "../../contexts/login";
import { logEvent, EVENT_TYPES } from "../../helpers/analytics-helper";
import useScrollLock from "../../hooks/useScrollLock";
import useCart from "../../ducks/cart/hooks/useCart";
import { set_reset_action } from "../../ducks/user/actions";
import useProfile from "../../ducks/user/hooks/useProfile";

interface PropTypes {
  login: (cellphone: any) => Promise<void>;
  verify: (code: any) => Promise<void>;
  loading: any;
  step: any;
}

function LoginModal(props: PropTypes) {
  let { login, verify, loading, step } = props;
  let { isLoginModalOpen, setLoginModalOpen } = useContext(LoginContext);
  let dispatch = useDispatch();
  let { enable, disable } = useScrollLock();
  let { data } = useProfile();
  let toast = useToast();

  let hasBasicProfile = useSelector(hasBasicProfileSelector);
  let { retrieve } = useCart();

  let hasFinishedLogin = hasBasicProfile;
  useEffect(() => {
    if (isLoginModalOpen) {
      setLoginModalOpen(!isLoginModalOpen);
    }
  }, [hasFinishedLogin]);
  useEffect(() => {
    if (isLoginModalOpen) {
      enable();
    } else {
      disable();
    }
  }, [isLoginModalOpen]);
  let dismiss = () => {
    logEvent(EVENT_TYPES.BUTTON_LOGIN_DISMISS);
    setLoginModalOpen(!isLoginModalOpen);
  };

  let ref = useRef();

  return (
    <Modal
      isVisible={
        data?.first_name === "" || data?.last_name === ""
          ? true
          : isLoginModalOpen
      }
      onSwipeComplete={dismiss}
      onBackdropPress={dismiss}
      swipeDirection={["down"]}
      style={{
        justifyContent: "flex-end",
        margin: 0,
        width: "100%",
        alignItems: "center",
      }}
      // this is for web
      onRequestClose={dismiss}
    >
      {step == LoginStepEnum.MOBILE && (
        <Box
          bg="common.white"
          style={{
            width: "100%",
            maxWidth: 768,
            borderTopRightRadius: 12,
            borderTopLeftRadius: 12,
          }}
        >
          <PhoneStep
            handleLogin={(cellphone) => {
              logEvent(EVENT_TYPES.BUTTON_LOGIN_PHONE);
              login(cellphone).catch((e: UIError) => {
                ref.current.show(e.body, { data: { type: "danger" } });
              });
            }}
            loading={loading}
          />
        </Box>
      )}
      {step == LoginStepEnum.VERIFY && (
        <ModalContent>
          <VerifyStep
            back={
              step == LoginStepEnum.VERIFY
                ? () => {
                    dispatch(set_reset_action());
                  }
                : undefined
            }
            handleVerify={(code) => {
              logEvent(EVENT_TYPES.BUTTON_LOGIN_VERIFY);
              verify(code)
                .then((res) => {
                  retrieve({ force: true });
                  if (!res.isNew) {
                    toast.show("با موفقیت وارد شدید.", {
                      data: { type: "success" },
                    });
                  }
                })
                .catch((e: UIError) => {
                  ref.current.show(e.body, { data: { type: "danger" } });
                });
            }}
            loading={loading}
          />
        </ModalContent>
      )}
      {step == LoginStepEnum.PROFILE && (
        <Box
          bg="common.white"
          style={{
            width: "100%",
            maxWidth: 768,
            borderTopRightRadius: 12,
            borderTopLeftRadius: 12,
          }}
        >
          <CompleteStep />
        </Box>
      )}
      {step == LoginStepEnum.UNKNOWN && <ActivityIndicator color="#0000ff" />}
      <Toast ref={ref} />
    </Modal>
  );
}

export default LoginModal;
